import { FileText, Target } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DetailsStepProps {
    title: string;
    description: string;
    onTitleChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    titleLabel?: string;
    titlePlaceholder?: string;
    descriptionLabel?: string;
    descriptionPlaceholder?: string;
}

const DetailsStep = ({
    title,
    description,
    onTitleChange,
    onDescriptionChange,
    titleLabel,
    titlePlaceholder,
    descriptionLabel,
    descriptionPlaceholder
}: DetailsStepProps) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                {t('goals.wizard.details.heading', 'Define your goal clearly')}
            </h3>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                        <Target className="w-4 h-4 mr-2 text-blue-500" />
                        {titleLabel || t('goals.wizard.details.titleLabel', 'Goal Title')}
                    </label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => onTitleChange(e.target.value)}
                        placeholder={titlePlaceholder || t('goals.wizard.details.titlePlaceholder', 'E.g., Develop a daily meditation habit')}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        aria-label={titleLabel || t('goals.wizard.details.titleLabel', 'Goal Title')}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                        <FileText className="w-4 h-4 mr-2 text-green-500" />
                        {descriptionLabel || t('goals.wizard.details.descriptionLabel', 'Detailed Description')}
                    </label>
                    <textarea
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        placeholder={descriptionPlaceholder || t('goals.wizard.details.descriptionPlaceholder', 'Describe your goal details, its purpose and why it is important for your personal growth...')}
                        rows={4}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        aria-label={descriptionLabel || t('goals.wizard.details.descriptionLabel', 'Detailed Description')}
                    />
                </div>
            </div>
        </>
    );
};

export default DetailsStep;